import {
	getBulkOperationParams,
	getCurrentSorting,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/common/bulk-action-utils.ts';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useMutation } from '@tanstack/react-query';
import { bulkSoftDeleteSecurities } from '@dealstack/frontend/shared/dataExchange/services/securities.ts';
import { BulkSoftDeleteSecuritiesDto } from '@dealstack/shared/lib/generated';
import { SecurityBulkOperationParams } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/types.ts';

export const useSecurityBulkDelete = (
	refetchSecurities: () => void,
	handleCheckExistingSecurityRefetch: () => void
) => {
	const tCapManage = useTranslationCapManage();
	const deleteSecuritiesRequest = useMutation({
		mutationFn: bulkSoftDeleteSecurities,
	});

	const deleteSecurities = async (params: SecurityBulkOperationParams) => {
		if (!params) {
			return;
		}

		const operationParams = getBulkOperationParams(params);
		const dataOperationParams = params.dataOperations ?? {};
		const sortBy = getCurrentSorting(params.table, dataOperationParams);

		deleteSecuritiesRequest.mutate(
			{
				selectedIds: operationParams.ids ?? [],
				excludedIds: operationParams.excludedIds ?? [],
				personId: operationParams.personId,
				...(operationParams.ids?.length
					? {}
					: {
							filter: dataOperationParams.filter,
							search: dataOperationParams.search,
							sortBy,
						}),
			} satisfies BulkSoftDeleteSecuritiesDto,
			{
				onSuccess: (res) => {
					handleCheckExistingSecurityRefetch();
					refetchSecurities();
					showToastV2({
						state: 'success',
						message: `${res?.count} ${tCapManage('toasts.success.security_deleted_successfully')}`,
					});
				},
				onError: () => {
					showToastV2({
						state: 'error',
						message: tCapManage('toasts.errors.failed_delete_security'),
					});
				},
			}
		);
	};

	return {
		deleteSecurities,
		isLoading: deleteSecuritiesRequest.isPending,
		deleteSecuritiesSuccess: deleteSecuritiesRequest.isSuccess,
	};
};
